import React, { useEffect, useState } from "react";
import RadioGroup from "../../components/radioButtons/RadioGroup";
import RadioButton from "../../components/radioButtons/RadioButton";
import Input from "../../components/inputs/Input";
import Checkbox from "../../components/checkboxes/Checkbox";
import Text from "../../components/typography/Text";
import Button from "../../components/buttons/Button";
import fetchApi from "../../fetchApi";

export default ({ data, setData, errors, setError, next, btnLabel, saved }) => {
	const [saveError, setSaveError] = useState();

	useEffect(() => {
		if (data) {
			const newCgu = data.cgu_1 && data.cgu_2;
			if (newCgu !== data.cgu) setData({ field: "cgu", value: newCgu });
		}
	}, [data]); // eslint-disable-line

	const verifyData = async () => {
		setError();
		let isOkay = true;
		if (!data["role"]) {
			setError({
				field: "role",
				message: "Please precise if you are an entrepreneur or a designer",
			});
			isOkay = false;
		}
		if (!data["email"] || !/.+@.+\..{2,3}/.test(data["email"])) {
			setError({ field: "email", message: "Please provide a correct email" });
			isOkay = false;
		}
		if (!data["password"] || data["password"].length < 8) {
			setError({
				field: "password",
				message: "Please provide a password with min. 8 chars.",
			});
			isOkay = false;
		}
		if (data["password"] !== data["password_verify"]) {
			setError({ field: "password_verify", message: "Passwords mismatch" });
			isOkay = false;
		}
		if (!data["cgu_1"] || !data["cgu_2"]) {
			setError({ field: "cgu", message: "Please accept CGU" });
			isOkay = false;
		}
		const emailIsAvailable = await checkAvailability();
		if (!emailIsAvailable) {
			setError({ field: "email", message: "This email is not available" });
			isOkay = false;
		}

		if (isOkay) {
			try {
				await next();
			} catch (err) {
				console.error(err);
				setSaveError(err);
			}
		}
	};

	const checkAvailability = async () => {
		try {
			const result = await fetchApi("/users/availability", {
				method: "post",
				body: { email: data["email"] },
			});
			return result.availabilty && result.availabilty.email;
		} catch (error) {
			console.error(error);
			return false;
		}
	};

	return (
		<div className="oUserForm">
			<h3>Sign Up</h3>
			<div className="oUserForm_role">
				<RadioGroup
					label="I am"
					required
					error={errors.some(({ field }) => field === "role")}
				>
					<RadioButton
						name="role"
						value="designer"
						label="Designer"
						checked={data["role"] === "designer"}
						setValue={(value) => setData({ field: "role", value })}
						bordered
					/>
					<div />
					<RadioButton
						name="role"
						value="contractor"
						label="Entrepreneur"
						checked={data["role"] === "contractor"}
						setValue={(value) => setData({ field: "role", value })}
						bordered
					/>
				</RadioGroup>
			</div>
			<div className="oUserForm_inputs">
				<Input
					label="Email"
					required
					value={data["email"]}
					setValue={(value) => setData({ field: "email", value })}
					error={errors.some(({ field }) => field === "email")}
					type="email"
				/>
				<Input
					label="Password"
					type="password"
					required
					value={data["password"]}
					setValue={(value) => setData({ field: "password", value })}
					error={errors.some(({ field }) => field === "password")}
				/>
				<Input
					label="Verify password"
					type="password"
					required
					value={data["password_verify"]}
					setValue={(value) => setData({ field: "password_verify", value })}
					error={errors.some(({ field }) => field === "password_verify")}
				/>
			</div>
			<div className="oUserForm_cgu">
				<Checkbox
					checked={data["cgu_1"]}
					setValue={() => setData({ field: "cgu_1", value: !data["cgu_1"] })}
					labelComponent={
						<Text small black>
							I agree to the EBD{" "}
							<a href="/terms-conditions" target="_blank">
								Terms of use
							</a>
							.
						</Text>
					}
				/>
				<Checkbox
					checked={data["cgu_2"]}
					setValue={() => setData({ field: "cgu_2", value: !data["cgu_2"] })}
					labelComponent={
						<Text small black>
							I agree that some of my information will be published online. I
							also confirm that I read carefully the{" "}
							<a href="/privacy-policy" target="_blank">
								Privacy Notice
							</a>
							.
						</Text>
					}
				/>

				{saveError && (
					<Text error small>
						An error occured. Please retry later or contact support.
					</Text>
				)}
			</div>
			{saved ? (
				<Button big green full>
					Saved !
				</Button>
			) : (
				<Button onClick={verifyData} big full>
					{btnLabel || "Continue"}
				</Button>
			)}
		</div>
	);
};
